<template>
  <div>
    <div id="media-items" class="media row mb-3">
      <div class="col-12 col-sm-8 d-flex align-items-center">
        <div class="input-group d-flex align-items-center">
          <input
            type="text"
            class="form-control"
            :placeholder="
              mediaTags.length == 0
                ? 'Search all media'
                : 'Search within selected media parameters'
            "
            aria-label="Search for"
            aria-describedby="basic-addon2"
            id="mediaSeachTerm"
          />
          <div class="input-group-append">
            <button
              id="mediaSearchButton"
              @click="updateSearchTerm"
              class="d-flex align-items-center btn btn-primary"
              type="button"
            >
              <i class="material-icons p-0" style="margin-right:7px">search</i>Search
            </button>
          </div>
        </div>
      </div>
      <div class="col-4 ml-auto d-none d-sm-flex pr-4 align-items-center justify-content-end">
        <router-link to="/media/upload" class="upload-button btn btn-success d-inline-block mr-2">
          <div style="display:flex; align-items:center">
            <i class="material-icons p-0" style="margin-right:7px">cloud_upload</i>
            <span class="d-none d-md-block">Upload Media</span>
          </div>
        </router-link>
      </div>
    </div>

    <!-- start of side -->
    <div class="row">
      <div class="col-md-3 col-lg-3 col-xl-3 filters-section">
        <div class="d-flex justify-content-start align-items-center">
          <i class="filter-icon material-icons -title mr-2 mt-1">filter_list</i>
          <h5 class="mt-4 mb-3">Filter Media</h5>
        </div>

        <div class="row">
          <div class="col-sm-4 col-md-12 mb-lg-3">
            <em class="filter-title">By File Type</em>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-3">
            <ul class="list-group flex-row flex-md-column">
              <li
                @click="selectPatientCondition(-1)"
                :class="{
                    active: selectedPatientCondition === -1,
                    'list-group-item': true
                  }"
              >All</li>
              <li
                @click="selectPatientCondition(0)"
                :class="{
                    active: selectedPatientCondition === 0,
                    'list-group-item': true
                  }"
              >Image</li>
              <li
                @click="selectPatientCondition(1)"
                :class="{
                    active: selectedPatientCondition === 1,
                    'list-group-item': true
                  }"
              >Video</li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-4 col-md-12 mb-lg-3 d-flex flex-row">
            <em class="filter-title">By Tag Name</em>
          </div>
        </div>
        <div class="row">
          <div class="col-12 mb-3">
            <TagSelector @tag-selection-updated="tagsUpdated" :availableTags="getMediaTags"></TagSelector>
          </div>
        </div>
      </div>
      <!-- end of side -->

      <div class="position-relative"></div>

      <div
        v-if="isLoading"
        class="w-75 d-flex position-absoloute flex-column justify-content-center align-items-center small-full"
      >
        <PleaseWait></PleaseWait>
      </div>

      <div
        class="w-75 d-flex position-absoloute flex-column justify-content-center align-items-center small-full"
        v-if="mediaCount == 0 && !isLoading"
      >
        <NoResults></NoResults>
      </div>

      <div
        v-if="mediaCount > 0  && !isLoading"
        class="col-sm col-md-9 col-lg-9 scenario-scroll-page"
      >
        <div class="row d-flex justify-content-end mr-4">
          <div v-if="mediaCount > 0 && !isLoading" class="results-count">
            <b class="deep">({{ mediaCount }})</b>
            Media Item{{ mediaCount != 1 ? 's' : '' }} available
          </div>
        </div>
        <div class="row d-flex justify-content-center">
          <div
            v-if="mediaCount > 0 "
            class="pagination-wrapper col-12 d-flex justify-content-end mt-3 mr-5"
          >
            <template>
              <paginate
                v-model="page"
                :page-count="pageCount"
                :page-range="3"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
              ></paginate>
            </template>
          </div>
        </div>
        <div class="row">
          <Media
            v-for="media in mediaObjects"
            :uuidId="media.uuid_id"
            :name="media.name"
            :signedThumbUrl="media.signed_thumb_url"
            :signedFullUrl="media.signed_full_url"
            :currentPrivacyLevel="media.privacy_level"
            :numDownloads="media.num_downloads"
            :fileSize="media.file_size"
            :tags="media.tags"
            :isProcessed="media.is_processed"
            :currentlyIsPublishable="media.is_publishable"
            :contributedBy="media.contributed_by"
          ></Media>
        </div>
        <div class="row d-flex justify-content-center">
          <div
            v-if="mediaCount > 0 "
            class="pagination-wrapper col-12 d-flex justify-content-end mt-3 mr-5"
          >
            <template>
              <paginate
                v-model="page"
                :page-count="pageCount"
                :page-range="3"
                :margin-pages="2"
                :click-handler="clickCallback"
                :prev-text="'Prev'"
                :next-text="'Next'"
                :container-class="'pagination'"
                :page-class="'page-item'"
              ></paginate>
            </template>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Media from "../components/Media";
import MediaService from "../services/media.service";
import TagSelector from "../components/TagSelector";
import Paginate from "../components/Paginate";
import LoadingSpinner from "../components/LoadingSpinner";
import NoResults from "../components/NoResults";
import PleaseWait from "../components/PleaseWait";
import MediaObject from "../objects/MediaObject";
import UserObject from "../objects/UserObject";
import TagObject from "../objects/TagObject";

export default {
  name: "MediaItems",
  deviceThumb: "",
  components: {
    Media,
    TagSelector,
    Paginate,
    LoadingSpinner,
    PleaseWait,
    NoResults
  },
  data: function() {
    return {
      isLoading: true,
      NUMBER_TO_GET: 4,
      pageCount: 0,
      page: 0,
      from: 0,
      to: 0,
      mediaItems: [],
      mediaTags: [],
      mediaCount: 0,
      selectedPatientAge: -1,
      searchTerm: -1,
      pageNum: 0,
      mediaObjects: [],
      selectedPatientCondition: -1
    };
  },
  props: {},
  methods: {
    getMediaItems(startAt) {
      this.isLoading = true;
      if (!this.searchTerm) {
        this.searchTerm = -1;
      }

      MediaService.media(
        startAt,
        this.NUMBER_TO_GET,
        this.searchTerm,
        this.mediaTags
      ).then(data => {
        this.mediaCount = data.total;
        this.mediaObjects = [];
        for (let mediaItem in data.media) {
          this.mediaObjects.push(new MediaObject(data.media[mediaItem]));
        }
        this.from = parseInt(data.from);
        this.to = parseInt(data.to);
        this.updatePageCount();
        this.isLoading = false;
      });
    },

    clickCallback: function(pageNum) {
      this.isActive = true;
      window.scrollTo(0, 0);
      this.page = pageNum;
      pageNum = pageNum - 1;
      this.mediaObjects = [];
      this.getMediaItems(this.NUMBER_TO_GET * pageNum);
    },

    getMediaTags() {
      return MediaService.mediaTags();
    },

    selectPatientAge(age) {
      this.isLoading = true;
      this.selectedPatientAge = age;
      this.getMediaItems();
    },

    selectPatientCondition(condition) {
      this.isLoading = true;
      this.selectedPatientCondition = condition;
      this.getMediaItems();
    },

    tagsUpdated(tags) {
      this.isLoading = true;
      this.mediaTags = tags;
      this.getMediaItems();
    },

    updatePageCount() {
      this.pageCount = Math.ceil(this.mediaCount / this.NUMBER_TO_GET);
    },

    updateSearchTerm() {
      this.searchTerm = document.getElementById("mediaSeachTerm").value;
      this.searchTerm = this.searchTerm
        .toLowerCase()
        .replace(/[^a-zA-Z0-9-_' ']/g, "");
      this.searchTerm = this.searchTerm.split(/[ ,]+/).join(",");
      this.getMediaItems();
    }
  },

  beforeMount() {
    this.isLoading = true;
  },

  mounted() {
    this.isLoading = true;
    this.getMediaItems(0);
    var input = document.getElementById("mediaSeachTerm");
    input.addEventListener("keyup", function(event) {
      if (event.keyCode === 13) {
        event.preventDefault();
        document.getElementById("mediaSearchButton").click();
      }
    });
  }
};
</script>

<style scoped>
.placeholder {
  min-height: 900px;
  z-index: 9;
  margin-bottom: 30px;
}

.media-item {
  min-height: 450px;
  margin-bottom: 30px;
}
.media-item {
  overflow: hidden;
}
.search-input {
  width: 100%;
  border: 1px solid black;
}
.media-item {
  /* padding: 7px; */
  margin-bottom: 30px;
  overflow: hidden;
}

.list-group-item {
  cursor: pointer;
}

ul.list-group li:not(:first-child):not(:last-child) {
  border-radius: 0px;
}

ul.list-group li:first-child {
  border-bottom-left-radius: 0px;
  border-bottom-left-radius: 0px;
}

ul.list-group li:last-child {
  border-top-left-radius: 0px;
  border-top-left-radius: 0px;
}

/* Medium Devices, Desktops */
@media only screen and (max-width: 992px) {
  .list-group-item {
    flex-grow: 1;
    border-radius: 5px;
    margin: 2px;
    text-align: center;

    display: flex;
    align-items: center;
    justify-content: center;
  }
  .sm-horizontal-scroll {
    max-width: 100vw;
    overflow-x: scroll;
    -webkit-overflow-scrolling: touch;
  }
}

.number-indicators {
  text-transform: capitalize;
}

.number-indicators b {
  color: #CB2E37;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.results-count {
  color: #6c757d;
  font-size: 14px;
}

.deep {
  color: #CB2E37;
}

@media (min-width: 992px) {
  .media-scroll-page {
  }
}

.lds-grid {
  display: inline-block;
  position: relative;
  width: 64px;
  height: 64px;
  position: absoloute;
  top: 0;
  left: 0;
  right: 0;
}
.lds-grid div {
  position: absolute;
  width: 13px;
  height: 13px;
  border-radius: 50%;
  background: #CB2E37;
  animation: lds-grid 1.2s linear infinite;
}
.lds-grid div:nth-child(1) {
  top: 6px;
  left: 6px;
  animation-delay: 0s;
}
.lds-grid div:nth-child(2) {
  top: 6px;
  left: 26px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(3) {
  top: 6px;
  left: 45px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(4) {
  top: 26px;
  left: 6px;
  animation-delay: -0.4s;
}
.lds-grid div:nth-child(5) {
  top: 26px;
  left: 26px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(6) {
  top: 26px;
  left: 45px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(7) {
  top: 45px;
  left: 6px;
  animation-delay: -0.8s;
}
.lds-grid div:nth-child(8) {
  top: 45px;
  left: 26px;
  animation-delay: -1.2s;
}
.lds-grid div:nth-child(9) {
  top: 45px;
  left: 45px;
  animation-delay: -1.6s;
}

[v-cloak] {
  display: none !important;
}

@keyframes lds-grid {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}

@media (max-width: 575.98px) {
  .filters-section .list-group {
    flex-wrap: wrap;
    justify-content: center;
  }
  .filters-section .list-group .list-group-item {
    min-width: 40%;
    max-width: 48%;
    border-radius: 0px !important;
  }
  .small-full {
    width: 100% !important;
  }
  .small-full div:first-child {
    text-align: center;
  }
  .upload-button {
    display: none;
  }

  /* Medium Devices, Desktops */
  @media only screen and (max-width: 992px) {
    .pagination-wrapper {
      margin: 0px !important;
      padding: 0px !important;
      display: flex;
    }
    .pagination-wrapper ul {
      display: flex;
      flex-wrap: wrap;
      justify-content: center;
    }
  }
}

em.filter-title {
  color: #6c757d;
}

.material-icons-title {
  font-size: 50px;
  color: #7d7d7d;
}

.filter-icon {
  font-size: 20px;
  color: #6c757d;
}

.upload-button {
  min-width: 176px;
}
</style>
